import { Skeleton } from "@/components/ui/skeleton"

/**
 * Skeleton dựng đúng bố cục thật của trình duyệt run: cột cây bên trái (đầu cột
 * có ô tìm + hàng chip lọc) và cột nội dung bên phải. Khung xương phải khớp bố
 * cục thật, nếu không lúc dữ liệu về màn hình sẽ nhảy một nhịp.
 */
export default function AgentQueueSkeleton() {
  return (
    <div className="flex h-full min-h-0 overflow-hidden bg-background">
      {/* Cột cây */}
      <div className="flex w-[380px] shrink-0 flex-col border-r bg-card">
        <div className="space-y-2 border-b px-3 py-2.5">
          <div className="flex items-center justify-between">
            <Skeleton className="h-3 w-10" />
            <Skeleton className="h-3 w-24" />
          </div>
          <Skeleton className="h-8 w-full" />
          <div className="flex flex-wrap gap-1">
            {["w-16", "w-12", "w-14", "w-20", "w-12", "w-24", "w-16"].map((width, index) => (
              <Skeleton key={index} className={`h-5 rounded-full ${width}`} />
            ))}
          </div>
          <div className="flex gap-1.5">
            <Skeleton className="h-7 flex-1" />
            <Skeleton className="h-7 flex-1" />
          </div>
        </div>
        <div className="space-y-1.5 p-2">
          {Array.from({ length: 12 }).map((_, index) => (
            <div key={index} className="flex items-center gap-2 px-1.5 py-1">
              <Skeleton className="h-3.5 w-3.5 rounded" />
              <Skeleton className="h-2.5 w-2.5 rounded-full" />
              <Skeleton className="h-3.5 flex-1" />
              <Skeleton className="h-3.5 w-6" />
            </div>
          ))}
        </div>
      </div>

      {/* Cột nội dung */}
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex items-center gap-3 border-b bg-card px-4 py-2">
          <Skeleton className="h-3.5 w-28" />
          <Skeleton className="h-5 w-24 rounded-full" />
          <Skeleton className="h-5 w-20 rounded-full" />
          <Skeleton className="h-5 w-20 rounded-full" />
          <Skeleton className="ml-auto h-6 w-20" />
        </div>
        <div className="flex flex-1 flex-col items-center justify-center gap-3">
          <Skeleton className="h-10 w-10 rounded-lg" />
          <Skeleton className="h-4 w-72" />
          <Skeleton className="h-3 w-96" />
        </div>
      </div>
    </div>
  )
}
